import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useGame } from '../context/GameContext';
import { AvatarChip } from '../components/Avatar';
import { ArrowLeft, Crown, Trophy } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HallOfChampions() {
  const { setScreen } = useGame();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(`${API}/weekly/champions?limit=100`);
        if (!cancelled) setRows(r.data?.champions || []);
      } catch (e) {}
      if (!cancelled) setLoading(false);
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="min-h-screen w-full px-6 py-6" data-testid="hall-of-champions-screen">
      <div className="flex items-center justify-between">
        <button className="brutal-btn text-sm" onClick={() => setScreen('menu')} data-testid="hall-back">
          <ArrowLeft size={16}/> BACK
        </button>
        <h1 className="font-display text-3xl sm:text-5xl font-black uppercase text-[#ffd700] flex items-center gap-3">
          <Crown /> HALL OF CHAMPIONS
        </h1>
        <div className="w-24"/>
      </div>

      <div className="mt-4 text-center text-xs uppercase tracking-widest text-[color:var(--text-dim)]">
        Every past Weekly Brawl winner, forever archived.
      </div>

      <div className="mt-6 max-w-3xl mx-auto space-y-2" data-testid="hall-list">
        {loading && (
          <div className="text-center text-[color:var(--text-dim)] py-8" data-testid="hall-loading">
            Loading champions…
          </div>
        )}
        {!loading && rows.length === 0 && (
          <div className="text-center text-[color:var(--text-dim)] py-8" data-testid="hall-empty">
            No champions crowned yet. Be the first — win this week's brawl.
          </div>
        )}
        {rows.map((r, i) => (
          <div
            key={r.week_key || i}
            className="flex items-center gap-3 p-3 brutal-border-dim"
            data-testid={`hall-row-${r.week_key}`}
            style={{ borderColor: i === 0 ? '#ffd700' : '#333', boxShadow: i === 0 ? '4px 4px 0 #ffd700' : 'none' }}
          >
            <div className="font-mono text-xs uppercase text-[color:var(--text-dim)] w-24 shrink-0" data-testid={`hall-week-${r.week_key}`}>
              {r.week_key || '—'}
            </div>
            <Crown size={16} className="text-[#ffd700] shrink-0"/>
            {r.avatar && (r.avatar.emoji || r.avatar.drawing) && (
              <AvatarChip avatar={r.avatar} size={30} testid={`hall-avatar-${r.week_key}`} />
            )}
            <div className="flex-1 font-display font-black uppercase truncate" data-testid={`hall-name-${r.week_key}`}>
              {r.player_name || 'ANON'}
            </div>
            {r.boss_defeated && <Trophy size={14} className="text-[color:var(--pink)] shrink-0"/>}
            <div className="text-xs font-mono text-[color:var(--text-dim)]">F{r.floor_reached}</div>
            <div className="text-sm font-mono text-[color:var(--neon)] font-bold" data-testid={`hall-score-${r.week_key}`}>
              {r.score}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
